import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { IPaginatedFilters } from 'src/app/shared/architecture/envelopes';
import { FrontOfficesService } from 'src/app/shared/services/core/front-offices.service';
import { ChangeDetectorRef } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-front-offices',
  imports: [TegelModule, CommonModule, NgxPaginationModule],
  templateUrl: './front-offices.component.html',
  styleUrl: './front-offices.component.scss'
})
export class FrontOfficesComponent implements OnInit {
  originalFrontOffices: any[] = [];
  frontoffices: any[];
  page = 1;
  pageSize = 10;
  searchText = '';
  private filtros:IPaginatedFilters = { paginationValue: '1', paginationSize: '10', columnKey: '', sortingDirection: '', query: ''};
  order = "userSSB"

  constructor(private frontOfficesService: FrontOfficesService, private cdr: ChangeDetectorRef) {
    this.frontoffices = [];
  }

  ngOnInit() {
    this.getAllFrontOffices();
  }

  getAllFrontOffices() {
    this.frontOfficesService.get().subscribe((result) => {
      if (result) {
        this.originalFrontOffices = result;
        this.frontoffices = result;
        this.cdr.detectChanges();
      }
    });

  }

  onFilterEvent(event: any) {
    const rawValue = event?.detail?.query ?? event?.target?.query ?? '';
    const value = String(rawValue).trim().toLowerCase();

    if (!value) {
      this.frontoffices = [...this.originalFrontOffices];
      this.page = 1;
      return;
    }

    const digits = value.replace(/\D/g, '');

    this.frontoffices = this.originalFrontOffices.filter(f => {
      const idMatch = digits ? String(f.userSSB).includes(digits) : false;
      const descMatch = f.name?.toLowerCase().includes(value);

      return idMatch || descMatch;
    });

    this.page = 1;
  }

  onSortEvent(event: any) {
  const column = event.detail.columnKey;
  const direction = event.detail.sortingDirection; 

  if (!column || direction === 'none') {
    return; 
  }

  
  this.frontoffices.sort((a: any, b: any) => {
    const dir = direction === 'asc' ? 1 : -1;

    if (a[column] > b[column]) return 1 * dir;
    if (a[column] < b[column]) return -1 * dir;
    return 0;
  });
}
}
